<template>
  <div class="iPickup w-full px-25 py-23 deliveryItem rounded-xl">
    <div class="text-white">
      <div v-html="lang.pickup" class="mb-3 free-title"></div>
      <div class="lowercase free">{{ lang.free }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IPickup",
  props: {
    lang: [],
  },
};
</script>

<style scoped>
.iPickup {
  min-height: 179px;
  background: linear-gradient(271.6deg, #5b66e2 0%, #954abf 100%);
}

.iPickup .free-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
}

.iPickup .free {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

.w-i-2 {
  width: calc(66.6666% + 0.75rem);
}

.w-i-1 {
  width: calc(33.3333% + 0.75rem);
}
</style>